/* eslint-disable prettier/prettier */
import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { CForm, CFormLabel, CFormInput, CButton } from '@coreui/react';
import { useNavigate } from "react-router-dom";
import AxiosInstance from '../Axios';
import { transliterate } from 'transliteration';

const CategoriesForm = (props) => {
    // console.log(props);
    let data = props.data;

    const [name, setName] = useState((data != undefined) ? data.name : '');
    const [slug, setSlug] = useState((data != undefined) ? data.slug : '');
    const [status, setStatus] = useState((data != undefined) ? data.status : '');
    const [type, setType] = useState((data != undefined) ? data.type : (props.currentCat || 'category'));
    const [parent, setParent] = useState((data != undefined) ? data.parent : '');
    const [sort, setSort] = useState((data != undefined && data?.sort) ? data.sort : 0);
    // const [Props, setProps] = useState(props);
    const editorRef = useRef(null);
    // Ключ для Editor
    const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;
    // Текст для popup
    const popupTextCategoryPostSuccess = "Категорію створено";
    const popupTextSubCategoryPostSuccess = "Підкатегорію створено";
    const popupTextCategoryPutSuccess = "Категорію оновлено";
    const popupTextError = "Помилка запиту";

    useEffect(() => {
        setName((data != undefined) ? data.name : '');
        setSlug((data != undefined) ? data.slug : '');
        setStatus((data != undefined) ? data.status : '');
        setType((data != undefined) ? data.type : (props.currentCat || 'category'));
        setParent((data != undefined) ? data.parent : '');
        setParent((data != undefined && data?.sort) ? data.sort : 0);
    }, [data, props]);

    let navigate = useNavigate();

    const handleSubmit = event => {
        event.preventDefault();
        let slugT;
        if (editorRef.current) {
            // console.log(editorRef.current.getContent());
            if (slug == '')
                slugT = transliterate(name).replace(' ', '');
            else
                slugT = transliterate(slug).replace(' ', '');

            let article = {
                name: name,
                slug: slugT,
                description: editorRef.current.getContent(),
                status: status,
                // parent: (props.parent != undefined)? `/api/categories/${parent}`: null,
                main: (props.parent != undefined) ? false : true,
                type: type,
                sort: parseInt(sort),
            };

            if (data != undefined && props.type === "sub") {
                article['parent'] = `/api/categories/${data.parent.id}`;
            } else if (props.type === "sub") {
                article['parent'] = (props.parent != undefined) ? `/api/categories/${props.parent}` : null;
            }

            if (data != undefined) {
                AxiosInstance.put('/categories/' + data.id, article).then((response) => {
                    // console.log('categories put response', response);
                    if (response.status === 200) {
                        // Передати наверх назву категорії
                        props.setMyData(response.data);

                        // Popup про успішні зміни
                        props.toastifySuccess(popupTextCategoryPutSuccess);
                    } else {
                        // console.log("Помилка запиту");
                        props.toastifyWarning(popupTextError);
                    }
                });
            } else {
                article.language = `/api/languages/1`;
                AxiosInstance.post('/categories', article).then((response) => {
                    // console.log('categories post response', response);
                    if (response.status == 201) {
                        if (props.type == 'page') {
                            // Popup про успішні зміни
                            props.toastifySuccess(popupTextCategoryPostSuccess);
                            return navigate("/category/update/" + response.data.id);
                        }
                        if (props.type == 'sub') {
                            // Popup про успішні зміни
                            props.toastifySuccess(popupTextSubCategoryPostSuccess);
                            props.actionShowModal(false);
                        }
                    } else {
                        // console.log("Помилка запиту");
                        props.toastifyWarning(popupTextError);
                    }
                    return response;
                });
            }
        }
    };

    return (
        <>
            <CForm onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-6'>
                        <div className="mb-3 info-col">
                            <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
                            <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" required />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3 info-col">
                            <CFormLabel htmlFor="exampleFormControlInput1">Синонім</CFormLabel>
                            <CFormInput type="text" id="exampleFormControlInput2" value={slug} onChange={(e) => setSlug(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3 info-col">
                            <CFormLabel htmlFor="exampleFormControlInput1">Статус</CFormLabel>
                            <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)} >
                                <option value="active">Активно</option>
                                <option value="disabled">Не активно</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3 info-col">
                            <CFormLabel htmlFor="exampleFormControlInput1">Тип</CFormLabel>
                            <select className="form-select" value={type} onChange={(e) => setType(e.target.value)} >
                                <option value="category">Категорія</option>
                                <option value="pages">Сторінки</option>
                                <option value="projects">Проекти</option>
                                <option value="faq">FAQ</option>
                                <option value="objects">Об'єкти</option>
                                <option value="attributes">Атрибути</option>
                                <option value="products">Продукти</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3 info-col">
                            <CFormLabel htmlFor="exampleFormControlInput1">Сортування</CFormLabel>
                            <CFormInput type="number" step={1} min={0} id="exampleFormControlInput2" value={sort} onChange={(e) => setSort(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                </div>

                <div className="mb-3">
                    <Editor
                        apiKey={apiKey}
                        onInit={(evt, editor) => editorRef.current = editor}
                        initialValue={(data != undefined) ? data.description : ''}
                        init={{
                            height: 200,
                            menubar: 'edit view insert format',
                            plugins: [
                                'advlist', 'autolink',
                                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'help', 'code'
                            ],
                            toolbar: 'undo redo | fontfamily fontsize | fontselect | bold italic backcolor | ' +
                                'alignleft aligncenter alignright alignjustify | ' +
                                'bullist numlist checklist outdent indent | removeformat | link media a11ycheck code table help',
                            content_style: 'body { font-family:FixelDisplayRegular; font-size:14px }',
                            font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Fixel Display Regular=fixelDisplayRegular; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                        }}
                    />
                </div>
                <CButton type="submit" color="success">Зберегти</CButton>
            </CForm>
        </>
    );
};

export default CategoriesForm;